export const TEST_ACTION_TYPE = 'TEST_ACTION_TYPE'
export const SET_JSON = 'SET_JSON'
export const CLEAR_JSON = 'CLEAR_JSON'
export const AUTH_USER = 'AUTH_USER'
export const GET_INVOICES = 'AUTH_USER'
export const MODIFY_INVOICE = 'MODIFY_INVOICE'
export const SET_ORIGINAL_JSON_VAL = 'SET_ORIGINAL_JSON_VAL'
export const MODIFY_INVOICE_ITEM_VALUE = 'MODIFY_INVOICE_ITEM_VALUE'
